const TYPE_LABELS = {
  Campanha: "Campanha",
  Banner: "Banner",
  Lookbook: "Lookbook",
  Video: "Vídeo",
  MaterialPdf: "Material PDF",
  Institucional: "Institucional",
  VmMerchandising: "VM / Merchandising",
};

export function getTypeLabel(tipo) {
  return TYPE_LABELS[tipo] || tipo;
}

const FULL_BANNER_TYPES = ["Banner", "Lookbook", "Campanha"];

export function getFavoriteKey(item) {
  const tipo = item.itemTipo || (item.isCampaign ? "Campanha" : "Conteudo");
  return `${tipo}:${item.id}`;
}

export function getDisplayImage(item) {
  if (item.imagemExibicao) return item.imagemExibicao;
  if (FULL_BANNER_TYPES.includes(item.tipo)) {
    return item.arquivoUrl || item.thumbnail || "";
  }
  if (item.tipo === "Video") return item.thumbnail || "";
  return item.thumbnail || item.arquivoUrl || "";
}

export function usesFullBannerImage(tipo) {
  return FULL_BANNER_TYPES.includes(tipo);
}

export function isEmbeddableVideoUrl(url) {
  if (!url) return false;
  const lower = url.toLowerCase();
  return (
    lower.includes("youtube.com") ||
    lower.includes("youtu.be") ||
    lower.includes("vimeo.com")
  );
}

export function getVideoEmbedUrl(url) {
  if (!url) return "";

  const trimmed = url.trim();

  if (trimmed.includes("youtube.com/embed/")) return trimmed;
  if (trimmed.includes("player.vimeo.com/video/")) return trimmed;

  const youtubeWatch = trimmed.match(
    /(?:youtube\.com\/watch\?.*v=|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
  );
  if (youtubeWatch) {
    return `https://www.youtube.com/embed/${youtubeWatch[1]}`;
  }

  const youtubeShort = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (youtubeShort) {
    return `https://www.youtube.com/embed/${youtubeShort[1]}`;
  }

  const youtubeShorts = trimmed.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  if (youtubeShorts) {
    return `https://www.youtube.com/embed/${youtubeShorts[1]}`;
  }

  const vimeo = trimmed.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return `https://player.vimeo.com/video/${vimeo[1]}`;
  }

  return trimmed;
}

export function formatPeriodo(dataInicio, dataFim) {
  const format = (date) => {
    if (!date) return "";
    const [y, m, day] = date.split("-");
    return `${day}/${m}/${y}`;
  };
  return `${format(dataInicio)} — ${format(dataFim)}`;
}

export function isContentActive(item) {
  if (item.status !== "Publicado") return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (!item.dataFim) return true;

  const [y, m, d] = item.dataFim.split("-");
  const fim = new Date(Number(y), Number(m) - 1, Number(d));
  return fim >= today;
}

export function matchesDestaqueTab(tipo, tabKey) {
  if (tabKey === "Material") {
    return ["MaterialPdf", "Institucional", "VmMerchandising"].includes(tipo);
  }
  if (tabKey === "Video") return tipo === "Video";
  if (tabKey === "Campanha") return tipo === "Campanha";
  return tipo === tabKey;
}

export function filterMarketingContents(
  contents,
  search,
  filters,
  favoriteKeys = [],
) {
  const term = search.trim().toLowerCase();
  const favoritesSet = new Set(favoriteKeys);

  const filtered = contents.filter((item) => {
    if (filters.apenasAtivos && !isContentActive(item)) return false;

    if (filters.apenasFavoritos && !favoritesSet.has(getFavoriteKey(item))) {
      return false;
    }

    if (term) {
      const matchesSearch =
        item.titulo.toLowerCase().includes(term) ||
        item.categoria.toLowerCase().includes(term) ||
        item.campanha?.toLowerCase().includes(term) ||
        item.tags?.some((tag) => tag.toLowerCase().includes(term));

      if (!matchesSearch) return false;
    }

    if (filters.tipos.length && !filters.tipos.includes(item.tipo))
      return false;
    if (
      filters.categorias.length &&
      !filters.categorias.includes(item.categoria)
    )
      return false;
    if (filters.campanhas.length && !filters.campanhas.includes(item.campanha))
      return false;

    return true;
  });

  const sorted = [...filtered];

  if (filters.ordenacao === "downloads") {
    sorted.sort((a, b) => b.downloads - a.downloads);
  } else {
    sorted.sort(
      (a, b) => new Date(b.dataAtualizacao) - new Date(a.dataAtualizacao),
    );
  }

  return sorted;
}

export function getUniqueFieldValues(contents, field) {
  return [
    ...new Set(contents.map((item) => item[field]).filter(Boolean)),
  ].sort();
}

export function isMaterialType(tipo) {
  return [
    "MaterialPdf",
    "Institucional",
    "VmMerchandising",
    "Lookbook",
  ].includes(tipo);
}
